export const handleKeyPress = (callback) => (event) => {
  if(event.key === 'Enter' || event.keyCode === 13){
    callback(event);
  }
}